"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _withIcon = _interopRequireDefault(require("../withIcon"));
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const IconDashboardFilled = props => {
  return /*#__PURE__*/(0, _jsxRuntime.jsx)("svg", {
    viewBox: "0 0 18 18",
    ...props,
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
      d: "M0,10 L8,10 L8,0 L0,0 L0,10 Z M0,18 L8,18 L8,12 L0,12 L0,18 Z M10,18 L18,18 L18,8 L10,8 L10,18 Z M10,0 L10,6 L18,6 L18,0 L10,0 Z"
    })
  });
};
var _default = exports.default = (0, _withIcon.default)('IconDashboardFilled')(IconDashboardFilled);